
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11759',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11759",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "dashboard-client-types": "static-1.283",
  "data-fetching-client": "static-1.9541",
  "foundations-components": "static-1.7644",
  "foundations-components-legacy": "static-1.669",
  "foundations-theming": "static-1.4275",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4884",
  "hs-test-utils": "static-1.7871",
  "hub-http-shared-msw-handlers": "static-1.9633",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11307",
  "I18n": "static-7.1592",
  "jasmine-runner": "static-1.6334",
  "marketplace-storefront-base": "static-1.11819",
  "quartz": "static-1.6815",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16514",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2727",
  "reporting-testing-lib": "static-1.8724",
  "settings-ui-lib": "static-1.12387",
  "SharedI18nStrings": "static-1.181",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6861",
  "ui-addon-i18n": "static-1.11009",
  "ui-addon-react-router-dom": "static-1.9409",
  "unified-auth": "static-1.300",
  "unified-auth-core-lib": "static-1.581",
  "usage-tracker": "static-1.7199",
  "usage-tracker-core": "static-1.7049",
  "customer-data-property-utils": "static-1.7944",
  "history": "static-4.47",
  "hub-http": "static-1.6082",
  "integrations-lib": "static-1.15625",
  "marketplace-ui-common": "static-1.19136",
  "property-management-iframe": "static-1.12624",
  "quartz-config": "static-1.593",
  "quartz-core": "static-1.6034",
  "quartz-routing": "static-1.245",
  "quick-fetch": "static-1.3798",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4506",
  "ts-schema": "static-1.3965",
  "ui-universal-auth": "static-1.8786",
  "UIComponents": "static-3.8254",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3290",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3092",
  "quartz-webpack": "static-1.3039",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3913",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4705",
  "foundations-theming-specialty": "static-1.1991",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9290",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5235",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.485",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1388",
  "ui-fonts": "static-1.569",
  "ui-images": "static-2.1117",
  "bend-plugin-foundations-theming": "static-1.2758",
  "foundations-theming-base": "static-1.3260",
  "stylex": "static-1.28",
  "HeadJS": "static-2.727",
  "hs-test-utils-bend-plugin": "static-1.2982",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4190",
  "ai-components-ui-library": "static-1.8543",
  "ai-rendering-library": "static-1.9513",
  "chirp-fetch": "static-1.1747",
  "connections-embed-lib": "static-1.726",
  "copilot-toolkit": "static-1.10702",
  "laboratory-lib": "static-3.7023",
  "marketplace-embed": "static-1.21644",
  "marketplace-ui-details": "static-1.9032",
  "marketplace-ui-reviews": "static-1.19092",
  "marketplace-ui-tracking": "static-1.13307",
  "sanitize-text": "static-1.8009",
  "ui-addon-video-player": "static-1.8560",
  "usage-tracker-multi": "static-1.5613",
  "usage-tracker-session-replay": "static-1.4885",
  "wootric-nps": "static-1.6846",
  "apollo-link-hub-http": "static-2.4515",
  "immer": "static-1.33",
  "immerable": "static-1.4018",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2408",
  "reporting-data": "static-1.66791",
  "cssUtils": "static-1.757",
  "flux-actions": "static-1.320",
  "HubStyle": "static-2.11615",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10075",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10238",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7189",
  "icons": "static-2.634",
  "marketplace-ui-apps-core": "static-1.17669",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4384",
  "foundations-components-test-utils": "static-1.5127",
  "quartz-i18n": "static-1.490",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3594",
  "customer-data-objects": "static-1.7516",
  "property-translator": "static-1.5273",
  "frontend-preferences-client": "static-1.7788",
  "hs-promise-utils": "static-1.5457",
  "hubspot-apollo-client": "static-1.4743",
  "integrations-error-boundary-lib": "static-1.13040",
  "integrations-tracking-lib": "static-1.5454",
  "native-integrations-shared-strings": "static-1.7651",
  "reselect": "static-2.16",
  "sanitize": "static-1.4338",
  "superstore": "static-1.4633",
  "ui-shepherd-react": "static-3.10010",
  "ai-settings-ui-library": "static-1.7648",
  "hub-http-janus": "static-1.812",
  "hubspotter-http": "static-1.4538",
  "immutable-less": "static-1.4518",
  "marketplace-ui-client-types": "static-1.16543",
  "nav-meta": "static-1.29122",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10106",
  "ui-addon-upgrades": "static-9.17752",
  "inbound-db-properties-service-client": "static-1.3731",
  "property-management-common": "static-1.4912",
  "ui-addon-iframeable": "static-1.8911",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.502",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.490",
  "quartz-head": "static-1.480",
  "quartz-test": "static-1.490",
  "quartz-tracking": "static-1.194",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3018",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20605",
  "ContentUtils": "static-1.67820",
  "sassPrefix": "static-1.153",
  "avatar-components": "static-1.2356",
  "customer-data-filters-ui": "static-1.39138",
  "customer-data-objects-ui-components": "static-1.12876",
  "customer-data-reference-ui-components": "static-1.13012",
  "embedded-academy-lib": "static-1.13781",
  "ExportDialog": "static-6.10252",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40826",
  "reporting-snowflake": "static-1.55409",
  "reporting-ui-components": "static-2.64062",
  "reporting-visualizations": "static-1.58867",
  "ui-addon-teams": "static-1.21332",
  "magpie-lib": "static-1.5458",
  "magpie-types": "static-1.4918",
  "simple-logging-lib": "static-1.2914",
  "navigation-components": "static-1.17485",
  "ai-studio-lib": "static-1.11173",
  "app-governance-lib": "static-1.1075",
  "developer-experience-shared-components": "static-1.10365",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7855",
  "ui-product-approvals": "static-1.27657",
  "ui-tool-access": "static-1.10009",
  "usage-based-billing-components-lib": "static-1.8187",
  "usage-tracker-anonymous": "static-1.5616",
  "usage-tracker-public": "static-1.7010",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3480",
  "persist-promise": "static-1.3572",
  "reference-resolvers": "static-1.8028",
  "ui-extensibility-client-types": "static-1.3805",
  "hubspot-apollo-cache": "static-1.202",
  "universal-page-editor-lib": "static-1.2865",
  "final-form": "static-1.66",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2356",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4934",
  "purchase-motions-components": "static-1.5583",
  "salesImages": "static-1.522",
  "batch-promise": "static-1.1415",
  "crm-component-utils": "static-1.38638",
  "crm-properties-common-lib": "static-1.5737",
  "customer-data-properties": "static-1.50989",
  "framework-data-schema-resolvers": "static-1.6737",
  "property-value-citations": "static-1.1603",
  "reference-resolvers-lite": "static-1.7949",
  "navigation-messaging": "static-1.6812",
  "hubspotter-http-shared-msw-handlers": "static-1.9631",
  "cms-field-types": "static-1.4673",
  "content-icons-ui": "static-1.2181",
  "conversations-skeleton-state": "static-1.7113",
  "crm-message-bus": "static-1.42559",
  "customer-data-filters-ui-msw-helpers": "static-1.21573",
  "customer-data-ui-utilities": "static-1.9688",
  "FormUrlGenerator": "static-2.4585",
  "framework-builder-read-service-client": "static-1.3893",
  "framework-data-schema-quick-fetch": "static-1.6642",
  "multi-account-reference-resolvers": "static-1.840",
  "onboarding-tours": "static-1.16351",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13241",
  "academy-common-lib": "static-1.13241",
  "content-assistance-lib": "static-1.7538",
  "dashboard-lib": "static-1.80892",
  "file-manager-components": "static-1.23111",
  "getting-started-shared-tasks": "static-1.18059",
  "hubspot-prosemirror": "static-1.17790",
  "hubspot-prosemirror-plugins": "static-1.17782",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19584",
  "share-with-third-party-component-lib": "static-1.8557",
  "ui-addon-draggable": "static-3.4632",
  "ui-asset-management-lib": "static-1.10800",
  "ui-business-units-lib": "static-1.8896",
  "user-context": "static-1.4964",
  "growth-payments-core": "static-1.24907",
  "reporting-plugins": "static-1.10059",
  "reporting-reports": "static-1.66469",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.589",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.28998",
  "react-codemirror": "static-1.10490",
  "framework-listing-lib": "static-2.28216",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30276",
  "apps-service-types": "static-1.3741",
  "oauth-service-types": "static-1.4111",
  "onboarding-scopes": "static-1.6327",
  "onboarding-tours-client": "static-1.4565",
  "platform-infra-nav-components": "static-1.7552",
  "subscription-experience-data-types": "static-1.14669",
  "crm-record-cards-service-types": "static-1.3502",
  "location-customization-utils-lib": "static-1.8763",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4363",
  "nav-client-types": "static-1.2221",
  "purchase-motions-api": "static-1.5586",
  "signup-constants": "static-1.18534",
  "signup-ui-url-generator": "static-2.7899",
  "trials-service-types": "static-1.3764",
  "card-properties-lib": "static-1.43706",
  "commerce-subscription-lib": "static-1.36641",
  "crm-actions": "static-1.6174",
  "crm-cards-sdk": "static-1.43108",
  "customer-data-properties-shared-msw-handlers": "static-1.8960",
  "customer-data-tracking": "static-1.6746",
  "hs-entities": "static-1.551",
  "pulse": "static-1.388",
  "calling-global-api": "static-1.63923",
  "calling-internal-common": "static-1.31164",
  "calling-lifecycle-internal": "static-1.65305",
  "calling-lifecycle-messages": "static-1.57599",
  "commerce-products-lib": "static-1.9024",
  "conditional-properties-service-client": "static-1.3683",
  "crm-links": "static-1.6133",
  "external-options-client-types": "static-1.4044",
  "google-libphonenumber": "static-1.34",
  "inbounddb-objects-service-types": "static-1.4108",
  "meetings-icalendar-utils-lib": "static-1.496",
  "multi-currency-client-types": "static-1.3575",
  "object-builder-ui-client": "static-1.48212",
  "pipeline-validation-client-types": "static-1.3849",
  "smart-property-lib": "static-1.6181",
  "tiered-pricing": "static-1.929",
  "ui-addon-form-validation": "static-1.10857",
  "crm-pipelines-api-client-types": "static-1.4025",
  "react-dnd-compat": "static-1.4484",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5223",
  "growth-onboarding-confetti": "static-1.2936",
  "growth-onboarding-next-action-utils": "static-1.1465",
  "onboarding-tours-utils": "static-1.417",
  "ui-shepherd-tracker": "static-1.7391",
  "academy-service-client": "static-1.3544",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28113",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8247",
  "video-components-external": "static-1.10775",
  "video-data-lib": "static-1.34433",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8422",
  "payment-link-components": "static-1.23107",
  "ui-addon-emoji-picker": "static-1.9751",
  "EmailSignatureEditor": "static-1.24026",
  "viral-links-lib": "static-1.6904",
  "data-token-picker": "static-1.16156",
  "FileManagerLib": "static-1.38751",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5108",
  "getting-started-shared-tasks-store": "static-1.17177",
  "campaign-roi-lib": "static-1.8472",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7186",
  "customer-data-views-management": "static-1.25117",
  "framework-data-table": "static-2.11572",
  "marketing-platform-lib": "static-1.6708",
  "nudge-client-utils": "static-1.2282",
  "nudge-custom-ui-functions": "static-1.787",
  "app-users-service-client": "static-1.5408",
  "app-users-service-types": "static-1.4816",
  "mini-checkout-client": "static-1.26475",
  "onboarding-utils": "static-1.5216",
  "permissions-shared-i18n-strings-fe": "static-1.1975",
  "ui-coaching-tips-shared-config": "static-1.28098",
  "edison-service-client-types": "static-1.256",
  "eligibility-engine-service-types": "static-1.3045",
  "crm_data": "static-4.91460",
  "customer-data-sidebar": "static-2.45587",
  "enrichment-properties-lib": "static-1.15299",
  "commerce-billing-lib": "static-1.18666",
  "commerce-shared-components-lib": "static-1.18125",
  "commerce-tools-ui-lib": "static-1.9960",
  "crm-fe-perf": "static-1.22768",
  "directed-graph": "static-1.803",
  "event-emitter": "static-1.811",
  "fast-json-patch": "static-1.59",
  "calling-error-reporting": "static-1.31170",
  "shared-worker-versioning": "static-1.10903",
  "calling-usage-tracker": "static-1.6405",
  "voice-sms-access-library": "static-1.432",
  "commerce-permissions": "static-1.627",
  "products-iframe-lib": "static-1.7509",
  "products-ui-components-shared-msw-handlers": "static-1.10015",
  "breeze-intelligence-kit": "static-1.5412",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9716",
  "policy-lib": "static-1.6642",
  "react-tinymce": "static-1.54803",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9779",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53929",
  "tinymce-plugins": "static-1.57043",
  "tinymce-themes": "static-1.55899",
  "growth-onboarding-next-action-components": "static-1.1493",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6445",
  "content-media-composition-data-lib": "static-1.11716",
  "content-media-compositions": "static-2.15723",
  "media-bridge-lib": "static-1.18678",
  "commerce-tours-lib": "static-1.5819",
  "growth-onboarding-reliability": "static-1.4950",
  "sales-checkout-service-client": "static-1.3532",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21422",
  "sales-email-signature-service-client": "static-1.3707",
  "audio-components": "static-1.5702",
  "FileManagerCore": "static-1.38610",
  "FileManagerImages": "static-1.36262",
  "video-components": "static-1.12778",
  "crm-export-dialog": "static-1.6157",
  "crm-index-associations-lib": "static-1.6299",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1493",
  "tanstack-virtual": "static-1.26",
  "nudge-custom-function-registry": "static-1.2039",
  "nudge-renderer-utils": "static-1.2358",
  "whisper-core-api": "static-1.6162",
  "InboxConnectUtils": "static-4.14392",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5206",
  "settings-content-modals": "static-1.45642",
  "crm_universal": "static-1.21758",
  "customer-data-email": "static-1.17783",
  "card-payment-highlight-lib": "static-1.36695",
  "card-subscription-highlight-lib": "static-1.39064",
  "commerce-contract-lib": "static-1.11436",
  "customer-data-content": "static-1.26996",
  "invoices-highlight-card-lib": "static-1.54231",
  "orders-highlight-card-lib": "static-1.21035",
  "products-highlight-card-lib": "static-1.17308",
  "project-storage": "static-1.4597",
  "quotes-highlight-card-lib": "static-1.71405",
  "crm-source-interpretation-lib": "static-1.5195",
  "utility-belt": "static-1.2404",
  "payments-enrollment-embed-lib": "static-1.22189",
  "customer-data-rte": "static-1.32603",
  "cv-backend-services": "static-1.1526",
  "growth-onboarding-empty-states": "static-1.5459",
  "payments-post-enroll-local-storage-lib": "static-1.4978",
  "qrcode-generator": "static-1.65",
  "quotes-client-types": "static-1.37495",
  "calling-orchestration-schema": "static-1.35209",
  "sales-views-client-types": "static-1.4135",
  "hub-http-contrib": "static-1.2907",
  "interframe": "static-3.4626",
  "tinymce-data": "static-1.40014",
  "ui-addon-sales-email": "static-1.5077",
  "layout-dnd-components": "static-1.12166",
  "layout-dnd-utils": "static-1.11141",
  "ui-brand-identity-lib": "static-1.14347",
  "NamespacedHubStyle": "static-2.8955",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4395",
  "video-embed": "static-1.35267",
  "social-insights-client-types": "static-1.21572",
  "deal-intel-utils": "static-1.1497",
  "checkout-sdk": "static-3.23318",
  "checkout-service-types": "static-1.3715",
  "company-details-components": "static-1.6049",
  "payment-method-components": "static-1.6756",
  "pricing-pages-ui-components": "static-1.12965",
  "quote-checkout-service-types": "static-1.3350",
  "upgrade-catalog-service-types": "static-1.3390",
  "access-control-lib": "static-1.10302",
  "EmailComponents": "static-1.54319",
  "EmailData": "static-1.52996",
  "redux-less": "static-2.9350",
  "sequences-lib": "static-1.7796",
  "ui-gdpr-components": "static-1.10212",
  "products-ui-components": "static-1.39543",
  "quotes-ui-lib": "static-1.80126",
  "SalesContentIndexUI": "static-3.9001",
  "accounting-integrations-ui-components": "static-1.6832",
  "invoices-ui-lib": "static-1.54247",
  "commerce-products-api": "static-1.2054",
  "SafeStorage": "static-1.4266",
  "invoices-iframe-lib": "static-1.56305",
  "quotes-modal-lib": "static-1.102083",
  "stripe-embedded-components": "static-1.7251",
  "draft-content-plugins": "static-1.27871",
  "ContentData": "static-1.67895",
  "layout-data-lib": "static-1.9466",
  "outpost": "static-1.4063",
  "hub-http-rxjs": "static-1.778",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3793",
  "billing-payments-client-types": "static-1.3853",
  "account-and-billing-fintech-outages": "static-3.18323",
  "pricing-pages-api": "static-1.12830",
  "ContentComponents": "static-2.70776",
  "marketing-contacts-lib": "static-1.9340",
  "marketing-email-service-types": "static-1.1813",
  "messaging-editing-lib": "static-1.45801",
  "messaging-usage-based-billing-components-lib": "static-1.663",
  "automation-ui-source-apps": "static-1.18406",
  "automation-ui-types": "static-1.19324",
  "messaging-types-lib": "static-1.45538",
  "onboarding-settings-client": "static-1.4369",
  "sequences-client-types-lib": "static-1.7653",
  "commerce-tax-lib": "static-1.382",
  "property-description-translator": "static-1.3719",
  "FireAlarmUi": "static-1.4393",
  "sales-templates-service-types-lib": "static-1.4052",
  "commerce-analytics-service-client": "static-1.3520",
  "totals-ui-components": "static-1.23159",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14908",
  "advanced-menus-lib": "static-1.11876",
  "ui-memberships-settings-lib": "static-1.33620",
  "demographics-service-types": "static-1.1513",
  "automation-ui-ubb": "static-1.5240",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7204",
  "data-token-views": "static-1.16137",
  "forms-utils-lib": "static-1.12295",
  "payments-embed-points-lib": "static-1.12730",
  "simple-menus-core": "static-1.14907",
  "simple-menus-lib": "static-1.16424",
  "ui-addon-draggable-compat": "static-2.4118",
  "videoconference-integration-components": "static-1.6618",
  "automation-applications-service-types": "static-1.3397",
  "automation-platform-service-types": "static-1.2543",
  "ContentEditorUI": "static-2.76707",
  "short-messages-app-service-client": "static-1.3867",
  "web-interactives-components": "static-1.13513",
  "web-interactives-data": "static-1.13514",
  "messaging-shared-utils-lib": "static-1.112",
  "messaging-user-info-utils-lib": "static-1.282",
  "email-portal-health-service-types": "static-1.840",
  "commerce-totals-service-types": "static-1.3701",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21260",
  "automation-ui-usage-tracking": "static-1.20723",
  "data-studio-ubb": "static-1.2285",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26594",
  "collaboration-sidebar": "static-1.57303",
  "content-management-data-lib": "static-1.5194",
  "copilot-plugins": "static-1.10675",
  "cta-picker": "static-1.36003",
  "customer-agent-discovery-components-lib": "static-1.2618",
  "editor-components": "static-1.13025",
  "editor-iframe-lib": "static-1.8206",
  "error-messaging-js": "static-1.5054",
  "FormsCommonComponents": "static-1.85448",
  "pictos": "static-7.181",
  "react-transition-group": "static-2.61",
  "redux-request-state": "static-1.10510",
  "SharedLegalStrings": "static-1.1616",
  "smart-content-core": "static-1.42025",
  "smart-content-lib": "static-1.42678",
  "social-composer-lib": "static-1.58395",
  "structured-content-lib": "static-1.24784",
  "theme-previewer-lib": "static-1.52853",
  "tinymce-copilot": "static-1.15997",
  "xray-recommendation-lib": "static-1.7680",
  "automation-ui-routing": "static-1.20681",
  "sql-reporting-client-types": "static-1.5530",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.41814",
  "campaigns-utils-lib": "static-1.3019",
  "reporting-enablement": "static-1.22313",
  "chatspot-widget-iframe": "static-1.20597",
  "collaboration-sidebar-common": "static-1.2100",
  "forms-ai-lib": "static-1.4098",
  "codemirror-dlb": "static-1.58266",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6291",
  "report-customization-components": "static-1.12698",
  "data-quality-ui-library": "static-1.12482",
  "html-to-image": "static-1.50",
  "reporting-insights-lib": "static-1.1256"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11759",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "dashboard-client-types": "/dashboard-client-types/static-1.283",
  "data-fetching-client": "/data-fetching-client/static-1.9541",
  "foundations-components": "/foundations-components/static-1.7644",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.669",
  "foundations-theming": "/foundations-theming/static-1.4275",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-test-utils": "/hs-test-utils/static-1.7871",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9633",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11307",
  "I18n": "/I18n/static-7.1592",
  "jasmine-runner": "/jasmine-runner/static-1.6334",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11819",
  "quartz": "/quartz/static-1.6815",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16514",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2727",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8724",
  "settings-ui-lib": "/settings-ui-lib/static-1.12387",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6861",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11009",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9409",
  "unified-auth": "/unified-auth/static-1.300",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.581",
  "usage-tracker": "/usage-tracker/static-1.7199",
  "usage-tracker-core": "/usage-tracker-core/static-1.7049",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7944",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6082",
  "integrations-lib": "/integrations-lib/static-1.15625",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19136",
  "property-management-iframe": "/property-management-iframe/static-1.12624",
  "quartz-config": "/quartz-config/static-1.593",
  "quartz-core": "/quartz-core/static-1.6034",
  "quartz-routing": "/quartz-routing/static-1.245",
  "quick-fetch": "/quick-fetch/static-1.3798",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4506",
  "ts-schema": "/ts-schema/static-1.3965",
  "ui-universal-auth": "/ui-universal-auth/static-1.8786",
  "UIComponents": "/UIComponents/static-3.8254",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3290",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3092",
  "quartz-webpack": "/quartz-webpack/static-1.3039",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3913",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4705",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1991",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9290",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5235",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1388",
  "ui-fonts": "/ui-fonts/static-1.569",
  "ui-images": "/ui-images/static-2.1117",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2758",
  "foundations-theming-base": "/foundations-theming-base/static-1.3260",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.727",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2982",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4190",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8543",
  "ai-rendering-library": "/ai-rendering-library/static-1.9513",
  "chirp-fetch": "/chirp-fetch/static-1.1747",
  "connections-embed-lib": "/connections-embed-lib/static-1.726",
  "copilot-toolkit": "/copilot-toolkit/static-1.10702",
  "laboratory-lib": "/laboratory-lib/static-3.7023",
  "marketplace-embed": "/marketplace-embed/static-1.21644",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9032",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19092",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13307",
  "sanitize-text": "/sanitize-text/static-1.8009",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8560",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5613",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4885",
  "wootric-nps": "/wootric-nps/static-1.6846",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4515",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4018",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2408",
  "reporting-data": "/reporting-data/static-1.66791",
  "cssUtils": "/cssUtils/static-1.757",
  "flux-actions": "/flux-actions/static-1.320",
  "HubStyle": "/HubStyle/static-2.11615",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10075",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10238",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7189",
  "icons": "/icons/static-2.634",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17669",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4384",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5127",
  "quartz-i18n": "/quartz-i18n/static-1.490",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3594",
  "customer-data-objects": "/customer-data-objects/static-1.7516",
  "property-translator": "/property-translator/static-1.5273",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7788",
  "hs-promise-utils": "/hs-promise-utils/static-1.5457",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4743",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13040",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5454",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7651",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4338",
  "superstore": "/superstore/static-1.4633",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10010",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7648",
  "hub-http-janus": "/hub-http-janus/static-1.812",
  "hubspotter-http": "/hubspotter-http/static-1.4538",
  "immutable-less": "/immutable-less/static-1.4518",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16543",
  "nav-meta": "/nav-meta/static-1.29122",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10106",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17752",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3731",
  "property-management-common": "/property-management-common/static-1.4912",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8911",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.502",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.490",
  "quartz-head": "/quartz-head/static-1.480",
  "quartz-test": "/quartz-test/static-1.490",
  "quartz-tracking": "/quartz-tracking/static-1.194",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3018",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20605",
  "ContentUtils": "/ContentUtils/static-1.67820",
  "sassPrefix": "/sassPrefix/static-1.153",
  "avatar-components": "/avatar-components/static-1.2356",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39138",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12876",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13012",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13781",
  "ExportDialog": "/ExportDialog/static-6.10252",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40826",
  "reporting-snowflake": "/reporting-snowflake/static-1.55409",
  "reporting-ui-components": "/reporting-ui-components/static-2.64062",
  "reporting-visualizations": "/reporting-visualizations/static-1.58867",
  "ui-addon-teams": "/ui-addon-teams/static-1.21332",
  "magpie-lib": "/magpie-lib/static-1.5458",
  "magpie-types": "/magpie-types/static-1.4918",
  "simple-logging-lib": "/simple-logging-lib/static-1.2914",
  "navigation-components": "/navigation-components/static-1.17485",
  "ai-studio-lib": "/ai-studio-lib/static-1.11173",
  "app-governance-lib": "/app-governance-lib/static-1.1075",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10365",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7855",
  "ui-product-approvals": "/ui-product-approvals/static-1.27657",
  "ui-tool-access": "/ui-tool-access/static-1.10009",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8187",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5616",
  "usage-tracker-public": "/usage-tracker-public/static-1.7010",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3480",
  "persist-promise": "/persist-promise/static-1.3572",
  "reference-resolvers": "/reference-resolvers/static-1.8028",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3805",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.202",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2865",
  "final-form": "/final-form/static-1.66",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2356",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4934",
  "purchase-motions-components": "/purchase-motions-components/static-1.5583",
  "salesImages": "/salesImages/static-1.522",
  "batch-promise": "/batch-promise/static-1.1415",
  "crm-component-utils": "/crm-component-utils/static-1.38638",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5737",
  "customer-data-properties": "/customer-data-properties/static-1.50989",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6737",
  "property-value-citations": "/property-value-citations/static-1.1603",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7949",
  "navigation-messaging": "/navigation-messaging/static-1.6812",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9631",
  "cms-field-types": "/cms-field-types/static-1.4673",
  "content-icons-ui": "/content-icons-ui/static-1.2181",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7113",
  "crm-message-bus": "/crm-message-bus/static-1.42559",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21573",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9688",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4585",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3893",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6642",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.840",
  "onboarding-tours": "/onboarding-tours/static-1.16351",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13241",
  "academy-common-lib": "/academy-common-lib/static-1.13241",
  "content-assistance-lib": "/content-assistance-lib/static-1.7538",
  "dashboard-lib": "/dashboard-lib/static-1.80892",
  "file-manager-components": "/file-manager-components/static-1.23111",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18059",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17790",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17782",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19584",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8557",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4632",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10800",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8896",
  "user-context": "/user-context/static-1.4964",
  "growth-payments-core": "/growth-payments-core/static-1.24907",
  "reporting-plugins": "/reporting-plugins/static-1.10059",
  "reporting-reports": "/reporting-reports/static-1.66469",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.589",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.28998",
  "react-codemirror": "/react-codemirror/static-1.10490",
  "framework-listing-lib": "/framework-listing-lib/static-2.28216",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30276",
  "apps-service-types": "/apps-service-types/static-1.3741",
  "oauth-service-types": "/oauth-service-types/static-1.4111",
  "onboarding-scopes": "/onboarding-scopes/static-1.6327",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4565",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7552",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14669",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3502",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8763",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4363",
  "nav-client-types": "/nav-client-types/static-1.2221",
  "purchase-motions-api": "/purchase-motions-api/static-1.5586",
  "signup-constants": "/signup-constants/static-1.18534",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7899",
  "trials-service-types": "/trials-service-types/static-1.3764",
  "card-properties-lib": "/card-properties-lib/static-1.43706",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36641",
  "crm-actions": "/crm-actions/static-1.6174",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43108",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8960",
  "customer-data-tracking": "/customer-data-tracking/static-1.6746",
  "hs-entities": "/hs-entities/static-1.551",
  "pulse": "/pulse/static-1.388",
  "calling-global-api": "/calling-global-api/static-1.63923",
  "calling-internal-common": "/calling-internal-common/static-1.31164",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65305",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57599",
  "commerce-products-lib": "/commerce-products-lib/static-1.9024",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3683",
  "crm-links": "/crm-links/static-1.6133",
  "external-options-client-types": "/external-options-client-types/static-1.4044",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4108",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.496",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3575",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48212",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3849",
  "smart-property-lib": "/smart-property-lib/static-1.6181",
  "tiered-pricing": "/tiered-pricing/static-1.929",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10857",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4025",
  "react-dnd-compat": "/react-dnd-compat/static-1.4484",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5223",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2936",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1465",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.417",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7391",
  "academy-service-client": "/academy-service-client/static-1.3544",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28113",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8247",
  "video-components-external": "/video-components-external/static-1.10775",
  "video-data-lib": "/video-data-lib/static-1.34433",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8422",
  "payment-link-components": "/payment-link-components/static-1.23107",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9751",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24026",
  "viral-links-lib": "/viral-links-lib/static-1.6904",
  "data-token-picker": "/data-token-picker/static-1.16156",
  "FileManagerLib": "/FileManagerLib/static-1.38751",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5108",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17177",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8472",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7186",
  "customer-data-views-management": "/customer-data-views-management/static-1.25117",
  "framework-data-table": "/framework-data-table/static-2.11572",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6708",
  "nudge-client-utils": "/nudge-client-utils/static-1.2282",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.787",
  "app-users-service-client": "/app-users-service-client/static-1.5408",
  "app-users-service-types": "/app-users-service-types/static-1.4816",
  "mini-checkout-client": "/mini-checkout-client/static-1.26475",
  "onboarding-utils": "/onboarding-utils/static-1.5216",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.1975",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28098",
  "edison-service-client-types": "/edison-service-client-types/static-1.256",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3045",
  "crm_data": "/crm_data/static-4.91460",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45587",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15299",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18666",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18125",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9960",
  "crm-fe-perf": "/crm-fe-perf/static-1.22768",
  "directed-graph": "/directed-graph/static-1.803",
  "event-emitter": "/event-emitter/static-1.811",
  "fast-json-patch": "/fast-json-patch/static-1.59",
  "calling-error-reporting": "/calling-error-reporting/static-1.31170",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10903",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6405",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.432",
  "commerce-permissions": "/commerce-permissions/static-1.627",
  "products-iframe-lib": "/products-iframe-lib/static-1.7509",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10015",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5412",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9716",
  "policy-lib": "/policy-lib/static-1.6642",
  "react-tinymce": "/react-tinymce/static-1.54803",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9779",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53929",
  "tinymce-plugins": "/tinymce-plugins/static-1.57043",
  "tinymce-themes": "/tinymce-themes/static-1.55899",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1493",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6445",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11716",
  "content-media-compositions": "/content-media-compositions/static-2.15723",
  "media-bridge-lib": "/media-bridge-lib/static-1.18678",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5819",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4950",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3532",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21422",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3707",
  "audio-components": "/audio-components/static-1.5702",
  "FileManagerCore": "/FileManagerCore/static-1.38610",
  "FileManagerImages": "/FileManagerImages/static-1.36262",
  "video-components": "/video-components/static-1.12778",
  "crm-export-dialog": "/crm-export-dialog/static-1.6157",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6299",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1493",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2039",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2358",
  "whisper-core-api": "/whisper-core-api/static-1.6162",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14392",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5206",
  "settings-content-modals": "/settings-content-modals/static-1.45642",
  "crm_universal": "/crm_universal/static-1.21758",
  "customer-data-email": "/customer-data-email/static-1.17783",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36695",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39064",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11436",
  "customer-data-content": "/customer-data-content/static-1.26996",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54231",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21035",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17308",
  "project-storage": "/project-storage/static-1.4597",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71405",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5195",
  "utility-belt": "/utility-belt/static-1.2404",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22189",
  "customer-data-rte": "/customer-data-rte/static-1.32603",
  "cv-backend-services": "/cv-backend-services/static-1.1526",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5459",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4978",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "quotes-client-types": "/quotes-client-types/static-1.37495",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35209",
  "sales-views-client-types": "/sales-views-client-types/static-1.4135",
  "hub-http-contrib": "/hub-http-contrib/static-1.2907",
  "interframe": "/interframe/static-3.4626",
  "tinymce-data": "/tinymce-data/static-1.40014",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5077",
  "layout-dnd-components": "/layout-dnd-components/static-1.12166",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11141",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14347",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8955",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4395",
  "video-embed": "/video-embed/static-1.35267",
  "social-insights-client-types": "/social-insights-client-types/static-1.21572",
  "deal-intel-utils": "/deal-intel-utils/static-1.1497",
  "checkout-sdk": "/checkout-sdk/static-3.23318",
  "checkout-service-types": "/checkout-service-types/static-1.3715",
  "company-details-components": "/company-details-components/static-1.6049",
  "payment-method-components": "/payment-method-components/static-1.6756",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.12965",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3350",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3390",
  "access-control-lib": "/access-control-lib/static-1.10302",
  "EmailComponents": "/EmailComponents/static-1.54319",
  "EmailData": "/EmailData/static-1.52996",
  "redux-less": "/redux-less/static-2.9350",
  "sequences-lib": "/sequences-lib/static-1.7796",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10212",
  "products-ui-components": "/products-ui-components/static-1.39543",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80126",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9001",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6832",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54247",
  "commerce-products-api": "/commerce-products-api/static-1.2054",
  "SafeStorage": "/SafeStorage/static-1.4266",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56305",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102083",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7251",
  "draft-content-plugins": "/draft-content-plugins/static-1.27871",
  "ContentData": "/ContentData/static-1.67895",
  "layout-data-lib": "/layout-data-lib/static-1.9466",
  "outpost": "/outpost/static-1.4063",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.778",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3793",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3853",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18323",
  "pricing-pages-api": "/pricing-pages-api/static-1.12830",
  "ContentComponents": "/ContentComponents/static-2.70776",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9340",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1813",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.45801",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.663",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18406",
  "automation-ui-types": "/automation-ui-types/static-1.19324",
  "messaging-types-lib": "/messaging-types-lib/static-1.45538",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4369",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7653",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.382",
  "property-description-translator": "/property-description-translator/static-1.3719",
  "FireAlarmUi": "/FireAlarmUi/static-1.4393",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4052",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3520",
  "totals-ui-components": "/totals-ui-components/static-1.23159",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14908",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11876",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33620",
  "demographics-service-types": "/demographics-service-types/static-1.1513",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5240",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7204",
  "data-token-views": "/data-token-views/static-1.16137",
  "forms-utils-lib": "/forms-utils-lib/static-1.12295",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12730",
  "simple-menus-core": "/simple-menus-core/static-1.14907",
  "simple-menus-lib": "/simple-menus-lib/static-1.16424",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4118",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6618",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3397",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2543",
  "ContentEditorUI": "/ContentEditorUI/static-2.76707",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3867",
  "web-interactives-components": "/web-interactives-components/static-1.13513",
  "web-interactives-data": "/web-interactives-data/static-1.13514",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.112",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.282",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.840",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3701",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21260",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.20723",
  "data-studio-ubb": "/data-studio-ubb/static-1.2285",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26594",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57303",
  "content-management-data-lib": "/content-management-data-lib/static-1.5194",
  "copilot-plugins": "/copilot-plugins/static-1.10675",
  "cta-picker": "/cta-picker/static-1.36003",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2618",
  "editor-components": "/editor-components/static-1.13025",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8206",
  "error-messaging-js": "/error-messaging-js/static-1.5054",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85448",
  "pictos": "/pictos/static-7.181",
  "react-transition-group": "/react-transition-group/static-2.61",
  "redux-request-state": "/redux-request-state/static-1.10510",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1616",
  "smart-content-core": "/smart-content-core/static-1.42025",
  "smart-content-lib": "/smart-content-lib/static-1.42678",
  "social-composer-lib": "/social-composer-lib/static-1.58395",
  "structured-content-lib": "/structured-content-lib/static-1.24784",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.52853",
  "tinymce-copilot": "/tinymce-copilot/static-1.15997",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7680",
  "automation-ui-routing": "/automation-ui-routing/static-1.20681",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5530",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.41814",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3019",
  "reporting-enablement": "/reporting-enablement/static-1.22313",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20597",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2100",
  "forms-ai-lib": "/forms-ai-lib/static-1.4098",
  "codemirror-dlb": "/codemirror-dlb/static-1.58266",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6291",
  "report-customization-components": "/report-customization-components/static-1.12698",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12482",
  "html-to-image": "/html-to-image/static-1.50",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1256"
}
};
